import React from 'react';
import { ArrowBack as ArrowBackIcon } from '@mui/icons-material';
import { Button } from '@mui/material';
import { FinalAllocation } from './AllocationFinalMessage.props';

interface GoToCapAllocationsProps {
  finalAllocations: FinalAllocation[];
  handleClick: (dateSlug: string, versionSlug: string) => void;
}

const GoToCapAllocations = ({ finalAllocations, handleClick }: GoToCapAllocationsProps) => (
  <Button
    variant="outlined"
    color="primary"
    onClick={() =>
      finalAllocations.length > 0
        && handleClick(finalAllocations[0].company_measurement_date?.measurement_date?.slug, finalAllocations[0]?.slug)
    }
    startIcon={<ArrowBackIcon />}>
    See Allocation
  </Button>
);

export default GoToCapAllocations;
